<template>
  <Login />
</template>

<script>
import Login from '../../components/auth/login_component.vue';

export default {
  components: {
    Login
  }
};
</script>